import { createSelector } from 'reselect';
import { getScopes } from '../../selectors/userSelectors/getScopes';
export const hasZorseDashboardAccess = createSelector(getScopes, scopes => scopes.includes('zorse-dashboard-access'));